var ClientFilterSubscribeRequest = require('services/control-client/client-filter-subscribe-request');
var TopicSelectorSerialiser = require('topics/topic-selector-serialiser');
var Codec = require('io/codec');

module.exports = {
    read : function(input) {
        var filter = Codec.readString(input);
        var selector = TopicSelectorSerialiser.read(input);

        return new ClientFilterSubscribeRequest(filter, selector);
    },
    write : function(output, request) {
        Codec.writeString(output, request.filter);
        TopicSelectorSerialiser.write(output, request.selector);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control-client/client-filter-subscribe-request-serialiser.js
// module id = 1007
// module chunks = 1